// Use Vite's import.meta.glob to preload all Vue components
const modules = import.meta.glob("../views/**/*.vue");

function loadView(view: string) {
  const path = `../views/${view}.vue`;
  return modules[path];
}

function handleUnauthorized(error: ErrorResponse, next: any) {
  if (error.status === 401) {
    next({ name: "error", params: { code: "401" } });
  }
}

export { loadView, handleUnauthorized };
